import type { PostHog } from 'posthog-js';

const noop = (): void => {};

/**
 * Stand-in for posthog-js in Vite dev: no init, no network. Production uses PostHogProvider + real client.
 */
export const posthogDevStub = {
  capture: noop,
  identify: noop,
  reset: noop,
  onSessionId: (_cb: (sessionId: string) => void): void => {},
} as unknown as PostHog;
